/**
 * 記事本文内のリンクを自動で装飾する
 * - 文中リンク: ファビコン付きのチップ風
 * - 段落にリンク単独: ドメイン名付きのミニカード風
 * ファビコンは Google の公開エンドポイント（ただの画像）を使うため API キー不要。
 * 取得失敗時はアイコンが消えるだけで、リンク自体は通常どおり機能する。
 */
(function () {
  function faviconUrl(host) {
    return 'https://www.google.com/s2/favicons?domain=' + encodeURIComponent(host) + '&sz=64';
  }

  function makeIcon(host, className) {
    var img = document.createElement('img');
    img.src = faviconUrl(host);
    img.alt = '';
    img.loading = 'lazy';
    img.className = className;
    img.addEventListener('error', function () {
      img.remove();
    });
    return img;
  }

  function linkHost(a) {
    try {
      return new URL(a.getAttribute('href'), window.location.href).hostname;
    } catch (e) {
      return null;
    }
  }

  function init() {
    var body = document.querySelector('.custom-article .article-body');
    if (!body) return;

    var links = body.querySelectorAll('a[href]');

    links.forEach(function (a) {
      var href = a.getAttribute('href') || '';

      // ページ内アンカー・メール・電話・画像リンクは対象外
      if (href.charAt(0) === '#' || /^(mailto|tel):/.test(href)) return;
      if (a.querySelector('img')) return;
      // 見出し・引用・コード内のリンクは装飾しない
      if (a.closest('h1, h2, h3, h4, pre, code, blockquote')) return;
      if (!a.textContent.trim()) return;

      var host = linkHost(a);
      if (!host) return;

      var isExternal = host !== window.location.hostname;
      if (isExternal) {
        a.target = '_blank';
        a.rel = 'noopener';
      }

      // 段落にこのリンクしかない場合はミニカードに昇格
      // （エディタがリンクを span/strong で包むことがあるため closest で段落を探し、
      //   段落のテキストがリンクのテキストと一致するかで判定する）
      var p = a.closest('p');
      var standalone = p &&
        p.textContent.trim() === a.textContent.trim() &&
        p.querySelectorAll('a').length === 1;

      if (standalone) {
        var title = a.textContent.trim();
        a.textContent = '';
        a.className = 'article-link-card';

        a.appendChild(makeIcon(host, 'article-link-card__icon'));

        var bodyEl = document.createElement('span');
        bodyEl.className = 'article-link-card__body';

        var titleEl = document.createElement('span');
        titleEl.className = 'article-link-card__title';
        titleEl.textContent = title;

        var domainEl = document.createElement('span');
        domainEl.className = 'article-link-card__domain';
        domainEl.textContent = host;

        bodyEl.appendChild(titleEl);
        bodyEl.appendChild(domainEl);
        a.appendChild(bodyEl);

        var arrowEl = document.createElement('span');
        arrowEl.className = 'article-link-card__arrow';
        arrowEl.textContent = '→';
        a.appendChild(arrowEl);

        p.classList.add('article-link-card-wrapper');
      } else {
        // 文中リンクはチップ風
        a.classList.add('article-link-chip');
        a.insertBefore(makeIcon(host, 'article-link-chip__icon'), a.firstChild);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
